import { NgModule } from '@angular/core';
import { ExtensionEditComponent } from './extension-edit/extension-edit.component';
import { ExtensionGridComponent } from './extension-grid/extension-grid.component';
import { ExtensionListComponent } from './extension-list/extension-list.component';
import { ExtensionListService } from '../core/service/grid-data/grid-data-extension.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    ExtensionEditComponent,
    ExtensionGridComponent,
    ExtensionListComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ExtensionListService
  ]
})
export class ExtensionModule { }
